import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'message-loader',
    templateUrl: './message-loader.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageLoaderComponent {
    public readonly avatarBotOrLive = input.required<string>();
    public readonly showAvatar = input<boolean>();
}
